import { RouterLink } from '@angular/router';
import { Component } from '@angular/core';

import { SiteOverviewInfoComponent } from '../../components/sites/site-overview-info/site-overview-info.component';
import { ClinicalDevicesComponent } from '../../components/sites/clinical-devices/clinical-devices.component';

@Component({
    selector: 'app-site-overview',
    imports: [SiteOverviewInfoComponent, RouterLink, ClinicalDevicesComponent],
    templateUrl: './site-overview.component.html',
    styleUrl: './site-overview.component.scss'
})
export class SiteOverviewComponent { }
